














import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { TopExpertsTableData } from "@/types";
import axios from "axios";
import BiExpertsTable from './BiExpertsTable.vue'


@Component({
  name: "BiExpertsByTaskId",

  components: {
    BiExpertsTable
  }
})
export default class BiTopExperts extends Vue {
  items: Array<TopExpertsTableData> = []
  taskName: string = ''

  mounted() {
    const taskId = this.$route.params.taskId
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/top-experts?filter[task_id]=${taskId}`)
      .then(value => {
        this.items = value.data.values
        this.taskName = this.items[0].task.name
      });
  }
}
